/**
 * Listing of all the routes of the application
 * @description use camel casing for the $path new routes property
 */
const $path = {
  //Dashboard
  dashboard: "/dashboard",

  // Account settings
  accountSettings: "/account-settings",

  // Login
  login: "/login",

  // Manage seed view
  seeds: "/seeds",

  // Password view
  password: "/password",

  // Users view
  users: "/users",

  // Customer view
  customers: "/customers",

  // Logged out view
  loggedOut: "/logged-out",

  // Manage mailbox providers
  mailboxProviders: "/mailbox-providers",

  // Accounts index page
  accounts: "/accounts",
  
  // Errors index page
  errors: "/errors",
};

// Forgot password view
$path.forgotPassword = `${$path.password}/forgot`;

// Add account view
$path.createAccount = `${$path.customers}/:customerId/accounts/create`;

// Edit account view
$path.editAccount = `${$path.customers}/:customerId/accounts/:id/edit`;

// create new customer
$path.createCustomer = `${$path.customers}/create`;

// User details
$path.user = `${$path.users}/:id/user`;

// Customer details
$path.customer = `${$path.customers}/:id/customer`;

// Create mailbox provider
$path.createMailboxProvider = `${$path.mailboxProviders}/create`;

// Mailbox provider show page
$path.mailboxProvider = `${$path.mailboxProviders}/:id`;

// Account show page
$path.account = `${$path.accounts}/:id`;

export default Object.freeze($path);
